import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { List, ListItem, ListItemButton, ListItemText, SxProps } from "@mui/material";
import { StyleguideSavioColors } from "../../configuration/themeSettings";



export const StyledList = styled(List, {
    label: "AppBasketMenu-dotMenuList",
})(({ theme: Theme }) => ({
    minWidth: "120px",
    paddingTop: 0,
    paddingBottom: 0,

    '@media print': {
        display: 'none !important',
    },

    '.MuiListItemButton-root': {
        borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,
        padding: '9px 16px',
        color: StyleguideSavioColors.blue,

        '&:hover': {
            backgroundColor: '#fff',
            textDecoration: 'underline',

            '.MuiTypography-root': {
                color: StyleguideSavioColors.blue,
            },

            '&:before': {
                display: 'block',
                content: "''",
                width: 3,
                height: '100%',
                backgroundColor: StyleguideSavioColors.blue,
                left: 0,
                position: 'absolute',
                zIndex: 1,
            }
        }
    },
    '.MuiTypography-root': {
        color: StyleguideSavioColors.text.black,
        fontSize: 14,
    },
}));